import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModule, NotificationModule } from '@seepex/ng-base';
import { CartCurrentListComponent, CartCurrentListItemPriceComponent, PageHeaderComponent, PromotionalPopupComponent, QuantitySelectorComponent } from './components';
import { AddToCartActionComponent } from './components/add-to-cart-action/add-to-cart-action.component';
import { CartCurrentListItemAvailabilityComponent } from './components/cart-current-list-item-availability/cart-current-list-item-availability.component';
import { ClearCartActionComponent } from './components/clear-cart-action/clear-cart-action.component';
import { CommonNoteComponent } from './components/common-note-section/common-note.component';
import { InfoItemComponent } from './components/info-item/info-item.component';
import { OrderInformationComponent } from './components/order-information/order-information.component';
import { QuoteInformationComponent } from './components/quote-information/quote-information.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { WithdrawInformationComponent } from './components/withdraw-information/withdraw-information.component';
import { BasePageModule } from './modules/base-page/base-page.module';
import { TableModule } from './modules/table';
import { CartCurrentListGroupHeaderPipe, CartCurrentListItemAvailablityPipe, WeightUnitPipe } from './pipes';
import { CartCurrentListPricePipe } from './pipes/cart-current-list-price.pipe';
import { CustomerContactService } from './services/customer-contact.service';
import { AppValidators } from './services/validators';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatDividerModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatTooltipModule,
    ReactiveFormsModule,
    BaseModule,
    NotificationModule,
    FlexLayoutModule,
    ScrollingModule,
    TableModule,
    BasePageModule,
    MatDatepickerModule,
    PortalModule,
    RouterModule,
  ],
  declarations: [
    PageHeaderComponent,
    CartCurrentListGroupHeaderPipe,
    CartCurrentListItemAvailablityPipe,
    CartCurrentListComponent,
    CartCurrentListItemPriceComponent,
    CommonNoteComponent,
    QuantitySelectorComponent,
    SearchBarComponent,
    InfoItemComponent,
    CartCurrentListItemAvailabilityComponent,
    CartCurrentListPricePipe,
    OrderInformationComponent,
    QuoteInformationComponent,
    WithdrawInformationComponent,
    ClearCartActionComponent,
    AddToCartActionComponent,
    WeightUnitPipe,
    PromotionalPopupComponent,
  ],
  exports: [
    PageHeaderComponent,
    CartCurrentListComponent,
    QuantitySelectorComponent,
    SearchBarComponent,
    BasePageModule,
    InfoItemComponent,
    CartCurrentListPricePipe,
    OrderInformationComponent,
    QuoteInformationComponent,
    WithdrawInformationComponent,
    AddToCartActionComponent,
    WeightUnitPipe,
    CommonNoteComponent,
    PromotionalPopupComponent,
  ],
  providers: [AppValidators, CustomerContactService],
})
export class SharedModule {}
